<template>
  <div class="bg-transparent py-4 md:px-0 sm:px-0 xs:px-0">
      <div class="flex justify-start">
        <div class="" v-for="(item,index) in items" :key="index">
            <div class="pb-1 cursor-pointer"
             :class="item.isActive?'border-b-4 border-blue-500':'border-b-4 border-gray-300'" @click="me(items,index)"
              v-bind:value="tab">
                <div class="text-center px-4">
                    <p :class="item.isActive===false?'text-gray-900':'text-gray-900'">
                      <span class="text-gray-900">{{item.name}}</span>
                      <span class="text-red-500">
                        <font-awesome-icon v-if="item.icon && item.icon!==false && item.icon!=='' && item.icon!==null"></font-awesome-icon>
                        <badges v-if="item.badge && item.badge!==false && item.badge!=='' && item.badge!==null" :value="item.badge" color="danger"></badges>
                      </span>
                    </p>
                </div>
            </div>        
        </div>  
      </div>
  </div>
</template>

<script>
export default {
  name: "stepper",
  props: {
    activeClass: {
      type: Object,
      default: {
        text_color: 'text-blue-600',
        icon_color: 'text-white',
        boder_color: 'border-blue-600',
        bg_color: 'bg-blue-600',
        line_color:'bg-gray-500'
      }
    },
    normalClass: {
      type: Object,
      default: {
        text_color: 'text-blue-600',
        boder_color: 'border-blue-600',
        bg_color: '',
        icon_color: 'text-blue-600',
        line_color:'bg-gray-500'
      }
    },
    items: {
      required: true,
      type: Array,
      default: [],
    },
    tab:null
  },
  data : () => ({

  }),
  methods:{
    me(items,index){
    let disable = items.find( Disable => Disable.isDisable === true);
      items.forEach(row => {
        row.isActive = false
      })
        items[index].isActive = true
        this.$store.dispatch('Fodes/setTab',items[index].codigo)
    },

  },

}
</script>

<style scoped>

</style>